import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { withErrorHandler } from "../../app/core-slice";
import { ProductsState } from "./products.types";
import { productsApi } from "./products.api";

const initialState: ProductsState = {
    filter: {
        searchTerm: "",
    },
    searchResults: {
        items: [],
        total: 0,
    },
    searchInprogress: false,
};

export const fetchProductsAsync = createAsyncThunk(
    "products/searchProducts",
    withErrorHandler(productsApi.searchProducts)
);

export const fetchProductAsync = createAsyncThunk("products/fetchProduct", withErrorHandler(productsApi.getProduct));

const productsSlice = createSlice({
    name: "products",
    initialState,
    reducers: {
        setProductsFilter(state, action: PayloadAction<any>) {
            state.filter = { ...state.filter, ...action.payload };
        },
        setCreateNewProduct(state, action: PayloadAction<boolean>) {
            state.createNew = action.payload;
        },
        clearEditingProduct(state) {
            state.editingProduct = undefined;
            state.createNew = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProductsAsync.pending, (state) => {
                state.searchInprogress = true;
            })
            .addCase(fetchProductsAsync.fulfilled, (state, action) => {
                state.searchResults = action.payload;
                state.searchInprogress = false;
            })
            .addCase(fetchProductsAsync.rejected, (state) => {
                state.searchInprogress = false;
            })
            .addCase(fetchProductAsync.pending, (state) => {
                state.editingProduct = undefined;
            })
            .addCase(fetchProductAsync.fulfilled, (state, action) => {
                state.editingProduct = action.payload;
            })
            .addCase(fetchProductAsync.rejected, (state) => {
                state.editingProduct = undefined;
            });
    },
});

export const { clearEditingProduct, setCreateNewProduct, setProductsFilter } = productsSlice.actions;

export default productsSlice.reducer;

//Selectors
export const selectProductsFilter = (state: RootState) => state.products.filter;
export const selectProductsSearchResults = (state: RootState) => state.products.searchResults;
export const selectProductsSearchInprogress = (state: RootState) => state.products.searchInprogress;
export const selectEditingProduct = (state: RootState) => state.products.editingProduct;
export const selectCreateNewProduct = (state: RootState) => state.products.createNew;
